import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Wallet } from "lucide-react";

function StatsCards({ stats, currency }) {
  if (!stats) {
    return (
      <div className="grid gap-4 md:grid-cols-3 mb-8">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="border border-border">
            <CardContent className="p-6">
              <div className="h-20 animate-pulse bg-muted rounded" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const balance = stats.total_income - stats.total_expenses - stats.total_savings;
  const savingsRate = stats.total_income > 0 
    ? ((stats.total_savings / stats.total_income) * 100).toFixed(1)
    : 0;

  return (
    <div className="grid gap-4 md:grid-cols-3 mb-8">
      <Card data-testid="income-card" className="border border-border transition-colors duration-200 hover:bg-slate-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                Total Income
              </p>
              <p className="text-2xl sm:text-3xl tracking-tight font-bold text-success">
                {currency} {stats.total_income.toFixed(2)}
              </p>
            </div>
            <div className="p-3 bg-success/10 rounded-md">
              <TrendingUp className="h-6 w-6 text-success" strokeWidth={1.5} />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card data-testid="expenses-card" className="border border-border transition-colors duration-200 hover:bg-slate-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                Total Expenses
              </p>
              <p className="text-2xl sm:text-3xl tracking-tight font-bold text-destructive">
                {currency} {stats.total_expenses.toFixed(2)}
              </p>
            </div>
            <div className="p-3 bg-destructive/10 rounded-md">
              <TrendingDown className="h-6 w-6 text-destructive" strokeWidth={1.5} />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card data-testid="balance-card" className="border border-border transition-colors duration-200 hover:bg-slate-50">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                Net Balance
              </p>
              <p className={`text-2xl sm:text-3xl tracking-tight font-bold ${
                balance >= 0 ? 'text-success' : 'text-destructive'
              }`}>
                {currency} {balance.toFixed(2)}
              </p>
              <p className="text-xs text-muted-foreground">
                Savings Rate: {savingsRate}%
              </p>
            </div>
            <div className="p-3 bg-accent/10 rounded-md">
              <Wallet className="h-6 w-6 text-accent" strokeWidth={1.5} />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default StatsCards;